import { useParams } from "react-router-dom";
import StaffPortalInstallGate from "@/components/mobile/StaffPortalInstallGate";

export default function DriverDashboardRedirect() {
  const { code } = useParams();
  if (!code) return null;

  return (
    <StaffPortalInstallGate
      kind="driver"
      code={code}
      shortHomePath={`/dd/${encodeURIComponent(code)}`}
      fetchPath={`/api/dd/${encodeURIComponent(code)}${window.location.search || ""}`}
    />
  );
}
